import React from "react";
import { Result } from "antd";
import { useSelector } from "react-redux";
import { t } from "i18next";
const EmptyCart = () => {
  const { companiesDetails } = useSelector((state) => state.mainReducer);
  return (
    <Result
      icon={
        <img
          className="empty-cart-logo"
          src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
          alt="emptyCart"
        />
      }
      title={t("noTicketsFound")}
    />
  );
};

export default EmptyCart;
